module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "vcroFormulaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(1), _vm._v(" "), _c('h6', {
    staticClass: "bold mb5 fs-13"
  }, [_vm._v("FACTORS")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fs-13 mb15"
  }, [_vm._v("A user's Risk Score = average of the factors that apply (a factor with no data is skipped, not counted as zero).")]), _vm._v(" "), (_vm.isAggregate) ? [_c('h6', {
    staticClass: "bold mb5 fs-13"
  }, [_vm._v(_vm._s(_vm.levelWord.toUpperCase()) + " SCORE")]), _vm._v(" "), _c('div', {
    staticClass: "fs-13 mb15"
  }, [_vm._v("The " + _vm._s(_vm.levelWord) + " Risk Score is the "), _c('strong', [_vm._v("median")]), _vm._v(" of its members' individual User Risk Scores, and each factor (Behavior / Training / Amplifier) is likewise the median of members' individual factor values: sort everyone's values and take the middle one, so a few outliers don't skew it the way a plain average would.")])] : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "bold mb5 fs-13"
  }, [_vm._v("RISK LEVELS")]), _vm._v(" "), _c('div', {
    staticClass: "fs-13"
  }, [_vm._v("Low 0–24 · Medium 25–49 · High 50–74 · Critical 75–100")])], 2), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("How the Risk Score is calculated")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fs-13 mb15"
  }, [_vm._v("A user's Risk Score is the "), _c('strong', [_vm._v("average of their active risk factors")]), _vm._v(" — each scored 0–100 (higher = more risk).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "fs-13 mt-0 pl-3"
  }, [_c('li', {
    staticClass: "mb5"
  }, [_vm._v("Behavior = (Clicked / Opened) × 100")]), _vm._v(" "), _c('li', {
    staticClass: "mb5"
  }, [_vm._v("Training = (Assigned − Evaluated) / Assigned × 100"), _c('br'), _c('span', {
    staticStyle: {
      "opacity": ".75",
      "font-style": "italic"
    }
  }, [_vm._v("Note: only mandatory trainings count toward the score.")])]), _vm._v(" "), _c('li', {
    staticClass: "mb5"
  }, [_vm._v("Amplifier = highest amplifier set by the company for the user or their groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-13 mb15"
  }, [_vm._v("Each factor is a 0–100 score and is "), _c('strong', [_vm._v("capped at 100")]), _vm._v(" — Behavior can work out above 100% when there are more clicks than opens, so it's clamped.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1790d4de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/vcro/components/VcroFormulaInfo.vue
// module id = 1461
// module chunks = 32